import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { UsLegalStatus } from '../utils/constants';
import type { UsLegalStatus as UsLegalStatusType } from '../utils/types';
type StatusFieldsProps = {
  onStatusChange: (newStatus: UsLegalStatusType) => void;
  disabled?: boolean;
};
export const StatusFields = t0 => {
  const $ = _c(29);
  const {
    onStatusChange,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.fields.usLegalStatus"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = diToFormData("id.us_legal_status");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = {
      label: t3,
      value: UsLegalStatus.citizen
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp2);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = {
      label: t5,
      value: UsLegalStatus.permanentResident
    };
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp3);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = {
      label: t7,
      value: UsLegalStatus.visa
    };
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t6 || $[16] !== t8) {
    t9 = [t4, t6, t8];
    $[14] = t4;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t(_temp4);
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = {
      required: t10
    };
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== onStatusChange) {
    t12 = e => onStatusChange(e.target.value as UsLegalStatusType);
    $[22] = onStatusChange;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== disabled || $[25] !== t11 || $[26] !== t12 || $[27] !== t9) {
    t13 = <div data-dd-privacy="mask" className="w-full flex flex-col gap-4"><Form.RadioGroup name={t2} disabled={disabled} options={t9} rules={t11} onChange={t12} /></div>;
    $[24] = disabled;
    $[25] = t11;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
function _temp($) {
  return $.statuses.citizen;
}
function _temp2($_0) {
  return $_0.statuses.permanentResident;
}
function _temp3($_1) {
  return $_1.statuses.visa;
}
function _temp4($_2) {
  return $_2.error;
}